export default "__VITE_ASSET__BJU$DxK8__"